/// <amd-module name="Wit/Common/QueryUtils/ErrorHandlingUtils" />
import { GlobalMessageLevel, IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { traceException } from "VSS/Platform/Trace";
import * as Resources from "Wit/Common/QueryUtils/Resources";
import * as QueriesHubConstants from "./QueriesHubConstants";

export function reportError(pageContext: IVssPageContext, feature: string, ex: Error | string): void {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");

    traceException(pageContext, QueriesHubConstants.TelemetryArea, feature, ex);

    const status = (ex as any).status || 0;
    const message = format(Resources.OperationFailed, `${ex instanceof Error ? ex.message : ex}${status ? " (" + status + ")" : ""}`);

    globalMessageService.addBanner(
        {
            message,
            dismissable: true,
            level: GlobalMessageLevel.error
        },
        /* closeExisting */ true
    );
}
